"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferSchema = exports.PartnerSchema = exports.IOfferType = void 0;
const mongoose_1 = require("mongoose");
var IOfferType;
(function (IOfferType) {
    IOfferType["GAMBLING"] = "gambling";
    IOfferType["BETTING"] = "betting";
    IOfferType["FIN"] = "fin";
})(IOfferType = exports.IOfferType || (exports.IOfferType = {}));
exports.PartnerSchema = new mongoose_1.Schema({
    partnerId: Number,
    shortName: String,
    name: String
});
exports.OfferSchema = new mongoose_1.Schema({
    id: { type: Number, unique: true },
    name: String,
    graphicFolder: String,
    graphic: {
        logo: String,
        bg: String
    },
    geo: String,
    caption: String,
    link: String,
    partnerId: Number,
    type: {
        type: String,
        enum: IOfferType,
        default: IOfferType.GAMBLING
    },
    keitaroId: String,
    hidden: Boolean,
    history: {
        link: [String],
        logoNames: [String],
        bgNames: [String],
        name: [String],
        caption: [String]
    }
});
